// extracted by mini-css-extract-plugin
export default {"floatDiv":"floatDivStyles_floatDiv__4eKM3","floatPrint":"floatDivStyles_floatPrint__fdc1K"};